import { profile } from "../data/mock";

const AboutMe = () => {
  return (
    <section id="aboutme" className="py-24 md:py-36 bg-[#F5F1EA]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Left: Headshot */}
          <div className="col-span-12 md:col-span-5 reveal">
            <div className="relative">
              <div className="aspect-[4/5] hover-zoom overflow-hidden bg-[#EEE8DB]">
                <img
                  src={profile.headshot}
                  alt="Kenny Rodriguez — San Marcos based photographer & videographer"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Editorial label overlay */}
              <div className="absolute -bottom-5 -right-4 md:-right-8 bg-[#1A1A1A] text-[#F5F1EA] px-5 py-3 shadow-xl">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#C2B8A3]">The Storyteller</div>
                <div className="font-display italic-display text-xl leading-tight mt-1">Kenny Rodriguez</div>
              </div>
            </div>
          </div>

          {/* Right: Bio */}
          <div className="col-span-12 md:col-span-7 md:pl-6 reveal">
            <div className="text-xs tracking-[0.25em] uppercase text-[#8B6F47] mb-5">
              (01.5) About Me
            </div>
            <h2 className="font-display text-[44px] md:text-[64px] leading-[1] tracking-tight">
              Hi, I'm <span className="italic-display text-[#8B6F47]">Kenny</span>.
            </h2>

            <div className="mt-8 space-y-5 max-w-xl text-[17px] md:text-[18px] leading-relaxed text-[#1A1A1A]/85 font-display">
              <p>
                Born and raised in San Antonio, Texas, I'm a Texas State University graduate with a
                Bachelor's in Electronic Media.
              </p>
              <p>
                Like any true Texan, I love a good Whataburger run — and above all, I belong to my
                King, Jesus Christ.
              </p>
              <p>
                Photography and film are how I notice the world, and how I try to honor the people
                in it.
              </p>
            </div>

            {/* Signature-style quick facts */}
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-[#1A1A1A]/15">
              <QuickFact label="Education" value="Texas State University" />
              <QuickFact label="Degree" value="B.S. Electronic Media" />
              <QuickFact label="Hometown" value="San Antonio, TX" />
              <QuickFact label="Now Based" value="San Marcos, TX" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const QuickFact = ({ label, value }) => (
  <div>
    <div className="text-[10px] tracking-[0.25em] uppercase text-[#1A1A1A]/55 mb-2">{label}</div>
    <div className="font-display text-base leading-snug">{value}</div>
  </div>
);

export default AboutMe;
